<template>
<section>
  <div class="card shadow-sm form-card mb-4">
    <div class="form-card-header">
      <div class="section-icon">
        <i class="fe fe-layers" style="font-size: 13px;"></i>
      </div>
      <h6 class="mb-0 font-weight-bold text-white">Add Drug Sub Category</h6>
    </div>
    <div class="card-body px-4 py-4">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="small font-weight-bold text-secondary">Parent Category <span class="text-danger">*</span></label>
          <select class="form-control" v-model="category_id">
            <option value="" disabled>Select category…</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.category_name }}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label class="small font-weight-bold text-secondary">Sub Category Name <span class="text-danger">*</span></label>
          <input type="text" required class="form-control" placeholder="e.g. Beta-lactams" v-model="sub_category_name">
        </div>
      </div>
      <button @click="addSubcategory" class="btn btn-submit">
        <i class="fe fe-plus mr-1"></i> Add Sub Category
      </button>
    </div>
  </div>

  <div class="card shadow-sm table-card">
    <div class="d-flex align-items-center px-4 pt-4 pb-3">
      <i class="fe fe-list text-primary mr-2"></i>
      <h6 class="mb-0 font-weight-bold">Existing Sub Categories</h6>
      <span v-if="Array.isArray(sub_categories)" class="badge badge-soft-info ml-2">{{ sub_categories.length }}</span>
    </div>
    <div class="px-4 pb-4">
      <ul class="category-list" v-if="Array.isArray(sub_categories) && sub_categories.length">
        <li v-for="cat in sub_categories" :key="cat.id" class="category-item d-flex align-items-center justify-content-between">
          <span class="category-name">{{ cat.sub_category_name }}</span>
          <button class="btn btn-sm btn-outline-danger" @click="deleteCategory(cat)">
            <i class="fe fe-trash-2"></i>
          </button>
        </li>
      </ul>
      <div v-else class="text-center text-muted py-4">
        <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
        <p class="mt-2 mb-0 small">No sub categories yet</p>
      </div>
    </div>
  </div>

  <div class="vld-parent">
    <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
  </div>
</section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: { Loading },
  data(){
    return{
      user: null,
      categories: "",
      category_id: "",
      sub_categories: "",
      sub_category_name: "",
      isLoading: false,
      fullPage: true,
    }
  },
  beforeMount(){
    this.axios.get(`/api/v1/auth/drug_category`)
              .then(response => { this.categories = response.data.data })
              .catch(error => { console.error(error) })
  },
  methods:{
    deleteCategory(cat){
      if (confirm('Are you sure you want to delete this sub category?')) {
        this.axios.delete(`/api/v1/auth/drug_subcategory/${cat.id}`)
                  .then(() => {
                    this.getSubCategories()
                    this.$toasted.success('Deleted Successfully!', {position: 'top-left', duration: 5000})
                  })
                  .catch(error => { console.error(error) })
      }
    },
    getCategories(){
      this.axios.get(`/api/v1/auth/drug_category`)
                .then(response => { this.categories = response.data.data })
                .catch(error => { console.error(error) })
    },
    getSubCategories(){
      this.axios.get(`/api/v1/auth/drug_subcategory`)
                .then(response => { this.sub_categories = response.data.data })
                .catch(error => { console.error(error) })
    },
    addSubcategory(){
      this.isLoading = true;
      this.axios.post('/api/v1/auth/drug_subcategory', {
        category_id: this.category_id,
        sub_category_name: this.sub_category_name,
      })
      .then(() => {
        this.isLoading = false;
        this.$toasted.success('Added Successfully!', {position: 'top-left', duration: 5000})
        this.getSubCategories()
        this.category_id = "";
        this.sub_category_name = "";
      })
      .catch(error => {
        console.log(error.response)
        this.isLoading = false;
        this.$toasted.error('Not Successful!', {position: 'top-left', duration: 5000})
      })
    },
  },
  created(){
    this.getCategories()
    this.getSubCategories()
  }
}
</script>

<style scoped>
.form-card, .table-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-icon {
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.category-item {
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
.category-item:last-child { border-bottom: none; }
.category-name { font-weight: 500; font-size: 0.9rem; }
.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 24px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37,99,235,0.15);
}
</style>
